interface Salesperson {
  name?: string;
  percentage?: number;
  amount?: number;
  [key: string]: any;
}

interface SalespersonsCellProps {
  salespersons: Salesperson[] | null;
}

export const SalespersonsCell = ({ salespersons }: SalespersonsCellProps) => {
  if (!salespersons || salespersons.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }

  const formatDisplay = (salesperson: Salesperson) => {
    const name = salesperson.name ?? "-";
    const percentage =
      salesperson.percentage !== undefined && salesperson.percentage !== null
        ? `${salesperson.percentage}%`
        : "-";

    return `${name} - ${percentage}`;
  };

  return (
    <div className="space-y-1 text-sm text-muted-foreground">
      {salespersons.map((salesperson, index) => (
        <div key={`${salesperson.name ?? "salesperson"}-${index}`}>
          {formatDisplay(salesperson)}
        </div>
      ))}
    </div>
  );
};
